<template>
  <div class="not-found-container">
    <div class="not-found-text">
      No hemos encontrado ningún resultado<br />
    </div>
    <div class="not-found-img">
      <img src="@/assets/no-items.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="sass">
.not-found-container
  grid-column-end: span 6
  width: 100%
  text-align: center
.not-found-text
  font-family: Montserrat
  font-size: 24px
  font-weight: 500
  font-style: normal
  font-stretch: normal
  line-height: normal
  letter-spacing: normal
  text-align: center
  color: #d0d0d0
.not-found-img
  margin-top: 50px
</style>

